import React, { useMemo, useState } from "react";
import { Table } from "antd";
import {
  EMPTY_PATIENTS_LABEL,
  PATIENTS_TITLE,
  getPatientsSummaryText,
} from "../../constants";
import DetailsCard from "../DetailsCard/DetailsCard";
import { getUserPatientsColumns } from "./columns";
import PatientDetailsModal from "./PatientDetailsModal/PatientDetailsModal";

const UserPatients = ({ patients = [], patientsCount, isLoading }) => {
  const [selectedPatient, setSelectedPatient] = useState(null);

  const columns = useMemo(
    () => getUserPatientsColumns({ onViewDetails: setSelectedPatient }),
    []
  );

  return (
    <DetailsCard
      title={PATIENTS_TITLE}
      summary={getPatientsSummaryText(patientsCount)}
    >
      <Table
        columns={columns}
        dataSource={patients}
        loading={isLoading}
        locale={{ emptyText: EMPTY_PATIENTS_LABEL }}
        pagination={false}
        rowKey="id"
        tableLayout="fixed"
      />

      <PatientDetailsModal
        patient={selectedPatient}
        onClose={() => setSelectedPatient(null)}
      />
    </DetailsCard>
  );
};

export default UserPatients;
